import React, { useState, useEffect } from 'react';
import { BrowserRouter, useNavigate, useLocation } from 'react-router-dom';

import './App.css';
import TeamsTab from './TeamRegistrationDisplay';
import ScheduleTab from './ScheduleTab';
import LiveTab from './LiveTab';
import NewsTab from './NewsTab';
import RegistrationTab from './RegistrationTab';
import SponsorBar from './SponsorBar'; // Import the new SponsorBar component

// Main App component that wraps the router
function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

// Main content component with navigation logic
function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('teams');
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  // Track mouse movement for parallax effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: e.clientX / window.innerWidth - 0.5,
        y: e.clientY / window.innerHeight - 0.5
      });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // Calculate the parallax effect values
  const headerTransform = {
    transform: `translate(${mousePosition.x * 15}px, ${mousePosition.y * 15}px) rotate(-2deg)`
  };
  
  const backgroundTransform = {
    transform: `translate(${mousePosition.x * -30}px, ${mousePosition.y * -30}px) translateX(-50%)`
  };

  // Map paths to tab names (for URL-to-tab synchronization)
  const pathToTab = {
    '/': 'teams',
    '/registracija': 'registration',
    '/tvarkarastis': 'schedule',
    '/live': 'live',
    '/naujienos': 'news'
  };

  // Map tab names to paths (for tab-to-URL synchronization)
  const tabToPath = {
    'teams': '/',
    'registration': '/registracija',
    'schedule': '/tvarkarastis',
    'live': '/live',
    'news': '/naujienos'
  };

  // Sync tab state with current URL path
  useEffect(() => {
    const path = location.pathname;
    const tab = pathToTab[path];
    
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    } else if (!tab && path !== '/') {
      // Redirect to home if path doesn't match any tab
      navigate('/', { replace: true });
    }
  }, [location.pathname, activeTab, navigate]);

  // Handle tab click
  const handleTabClick = (tab) => {
    if (tab === activeTab) return;
    
    setActiveTab(tab);
    navigate(tabToPath[tab]);
  };

  // Render the active tab content
  const renderTabContent = () => {
    switch (activeTab) {
      case 'teams':
        return <TeamsTab />;
      case 'registration':
        return <RegistrationTab />;
      case 'schedule':
        return <ScheduleTab />;
      case 'live':
        return <LiveTab />;
      case 'news':
        return <NewsTab />;
      default:
        return <TeamsTab />;
    }
  };

  return (
    <div className="App">
      <div className="graffiti-splatter top-left"></div>
      <div className="graffiti-splatter bottom-right"></div>
      
      <header className="app-header">
        <h1 style={headerTransform}></h1>
        <p
          className="subtitle"
          style={{
            transform: `translate(${mousePosition.x * 10}px, ${mousePosition.y * 10}px) rotate(-1deg)`
          }}
        >
          Beach Bros Turnyro Informacija
        </p>
    </header>
      <nav className="app-tabs">
        <button
          className={`tab-button ${activeTab === 'teams' ? 'active' : ''}`}
          onClick={() => handleTabClick('teams')}
        >
          Komandos
        </button>
        <button
          className={`tab-button registration-button ${activeTab === 'registration' ? 'active registration-button' : 'registration-button'}`}
          onClick={() => handleTabClick('registration')}
        >
          Registracija
        </button>
        <button
          className={`tab-button ${activeTab === 'schedule' ? 'active' : ''}`}
          onClick={() => handleTabClick('schedule')}
        >
          Tvarkaraštis
        </button>
        <button
          className={`tab-button ${activeTab === 'live' ? 'active' : ''}`}
          onClick={() => handleTabClick('live')}
        >
          Live Transliacija
        </button>
        <button
          className={`tab-button ${activeTab === 'news' ? 'active' : ''}`}
          onClick={() => handleTabClick('news')}
        >
          Naujienos
        </button>
      </nav>

      <main className="tab-content" style={{ transform: `translate(${mousePosition.x * 5}px, ${mousePosition.y * 5}px)` }}>
        {renderTabContent()}
      </main>

      <footer className="app-footer">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <div className="graffiti-tag">BEACH BROS © {new Date().getFullYear()}</div>
      </footer>
      
      {/* Add the SponsorBar component */}
      <SponsorBar />
    </div>
  );
}

export default App;